import React, { FC, memo } from 'react';
import { getGlobalSettings } from 'app/appState';
import { CookieConsent as ReactCookieConsent } from 'react-cookie-consent';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

export const CookieConsent: FC = memo(() => {
  const globalSettings = useAppSelector(getGlobalSettings);
  const { t } = useAppTranslation('common');
  const { isDesktop } = useScreenBreakpoints();

  return (
    <ReactCookieConsent
      location="bottom"
      buttonText={t('Accept')}
      cookieName="cookieConsent"
      style={{
        background: globalSettings?.themeColors.primary,
        padding: '0px 10px',
        display: 'flex',
        flexDirection: `${isDesktop ? 'row' : 'column'}`,
        alignItems: `${isDesktop ? 'center' : 'flex-end'}`,
      }}
      buttonStyle={{
        background: globalSettings?.themeColors.accent,
        color: globalSettings?.themeColors.white,
        fontSize: `${isDesktop ? '20px' : '14px'}`,
        padding: '8px 20px',
        borderRadius: '4px',
      }}
      contentStyle={{
        flex: 'unset',
      }}
      // enableDeclineButton
      //   declineButtonText={t('Decline')}
      //   declineButtonStyle={{
      //     background: globalSettings?.themeColors.warn,
      //     color: globalSettings?.themeColors.white,
      //     fontSize: '20px',
      //     padding: '8px 20px',
      //     borderRadius: '4px',
      //   }}
      onAccept={() => {
        if ((window as CustomAny).gtag) {
          (window as CustomAny).gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            functionality_storage: 'granted',
            personalization_storage: 'granted',
            security_storage: 'granted',
          });
        }
      }}
    >
      <span className="text-white desktop:text-xl">{t('We use cookies to ensure you get the best experience on our website.')}</span>
    </ReactCookieConsent>
  );
});
